export default class InstructorLoggedIn {
  static type = 'InstructorLoggedIn';
  constructor(instructorId) {
    if (typeof instructorId !== 'string') throw new TypeError('instructorId must be a string');
    this.instructorId = instructorId;
  }
}
